document.addEventListener('DOMContentLoaded', () => {

  // CURSOR
  // const cur = document.getElementById('cursor'), dot = document.getElementById('cursorDot');
  // let mx=0,my=0,cx=0,cy=0;
  // document.addEventListener('mousemove', e => {
  //   mx=e.clientX; my=e.clientY;
  //   if(dot){dot.style.left=mx+'px';dot.style.top=my+'px';}
  // });
  // (function a(){cx+=(mx-cx)*.12;cy+=(my-cy)*.12;if(cur){cur.style.left=cx+'px';cur.style.top=cy+'px';}requestAnimationFrame(a);})();

  // HEADER SCROLL
  window.addEventListener('scroll',()=>document.getElementById('siteHeader')?.classList.toggle('scrolled',scrollY>40),{passive:true});

  // REVEAL ON SCROLL
  const obs=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target);}}),{threshold:.1});
  document.querySelectorAll('.rv').forEach(el=>obs.observe(el));

  // PANEL HELPERS
  const pgOv=document.getElementById('pgOverlay');
  const cartEl=document.getElementById('cartDrawer');
  const searchEl=document.getElementById('searchOverlay');
  const mobEl=document.getElementById('mobNav');
  const clearAll=()=>{pgOv?.classList.remove('on');document.body.style.overflow='';};

  function openCart(){cartEl?.classList.add('open');pgOv?.classList.add('on');document.body.style.overflow='hidden';}
  function closeCart(){cartEl?.classList.remove('open');clearAll();}
  function openSearch(){searchEl?.classList.add('active');pgOv?.classList.add('on');setTimeout(()=>searchEl?.querySelector('input')?.focus(),200);}
  function closeSearch(){searchEl?.classList.remove('active');clearAll();}
  function openMob(){mobEl?.classList.add('open');pgOv?.classList.add('on');document.body.style.overflow='hidden';}
  function closeMob(){mobEl?.classList.remove('open');clearAll();}

  document.getElementById('openCart')?.addEventListener('click',openCart);
  document.getElementById('closeCart')?.addEventListener('click',closeCart);
  document.getElementById('contShop')?.addEventListener('click',closeCart);
  document.getElementById('openSearch')?.addEventListener('click',openSearch);
  document.getElementById('closeSearch')?.addEventListener('click',closeSearch);
  document.getElementById('openMob')?.addEventListener('click',openMob);
  document.getElementById('closeMob')?.addEventListener('click',closeMob);
  pgOv?.addEventListener('click',()=>{closeCart();closeSearch();closeMob();closeSz();});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeCart();closeSearch();closeMob();closeSz();}});

  // SIZE GUIDE MODAL
  const szModal=document.getElementById('szModal');
  function openSz(e){e?.preventDefault();szModal?.classList.add('on');document.body.style.overflow='hidden';}
  function closeSz(){szModal?.classList.remove('on');document.body.style.overflow='';}
  document.getElementById('openSzGuide')?.addEventListener('click',openSz);
  document.querySelectorAll('[data-open-size-guide]').forEach(el=>el.addEventListener('click',openSz));
  document.getElementById('szClose')?.addEventListener('click',closeSz);
  document.getElementById('szBg')?.addEventListener('click',closeSz);

  // ── SHOPIFY AJAX CART ────────────────────────────────

  function formatMoney(cents) {
    return '€\u00A0' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function updateCartBadge(count) {
    // Update header cart icon badge
    const badge = document.getElementById('cartCount');
    if (badge) {
      badge.textContent = count;
      badge.style.transform = 'scale(1.5)';
      setTimeout(() => badge.style.transform = '', 300);
    }
    // FIX 1: Also update the "(N)" count inside the cart drawer title
    const titleCount = document.getElementById('cartItemCount');
    if (titleCount) titleCount.textContent = count;
  }

  async function refreshCartDrawer() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      updateCartBadge(cart.item_count);
      rebuildCartBody(cart);
    } catch(e) { console.error('Cart refresh:', e); }
  }

  function rebuildCartBody(cart) {
    const drawer = document.getElementById('cartDrawer');
    const body   = document.querySelector('.cart-body');
    if (!body || !drawer) return;

    // EMPTY STATE
    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <p class="cart-empty-title">Your bag is empty</p>
          <p class="cart-empty-text">Discover our new collection</p><br>
          <a href="/collections/all" class="btn btn-dark"><span>Shop Now</span></a>
        </div>`;
      const existingFt = drawer.querySelector('.cart-ft');
      if (existingFt) existingFt.style.display = 'none';
      return;
    }

    // HAS ITEMS — rebuild body
    const upsell = body.querySelector('.cart-upsell');
    let html = upsell ? upsell.outerHTML : '';

    cart.items.forEach((item) => {
      const variantLabel = item.variant_title && item.variant_title !== 'Default Title'
        ? item.variant_title : '';
      // FIX 3: Added delete (remove) button per cart item
      html += `
        <div class="cart-item" data-key="${item.key}">
          <img class="cart-img" src="${item.image}" alt="${item.product_title}">
          <div class="ci-details">
            <div class="ci-top-row">
              <div class="ci-name">${item.product_title}</div>
              <button class="ci-remove" data-key="${item.key}" aria-label="Remove item" title="Remove">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
                  <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
                </svg>
              </button>
            </div>
            <div class="ci-var">${variantLabel}</div>
            <div class="ci-price">${formatMoney(item.final_line_price)}</div>
            <div class="qty-row">
              <button class="qty-btn" data-a="minus" data-key="${item.key}">−</button>
              <span class="qty-num">${item.quantity}</span>
              <button class="qty-btn" data-a="plus"  data-key="${item.key}">+</button>
            </div>
          </div>
        </div>`;
    });
    body.innerHTML = html;

    // ROOT CAUSE FIX:
    // cart-drawer.liquid uses {% if cart.item_count > 0 %} to render .cart-ft.
    // On page load with empty cart, .cart-ft is NEVER rendered into the DOM.
    // querySelector('.cart-ft') returns null — setting .style.display on null does nothing.
    // Fix: if .cart-ft does not exist yet, CREATE and INJECT it into the drawer.
    let footer = drawer.querySelector('.cart-ft');

    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'cart-ft';
      footer.innerHTML =
        '<div class="cart-sub">' +
          '<span class="sub-lbl">Subtotal</span>' +
          '<span class="sub-price">' + formatMoney(cart.total_price) + '</span>' +
        '</div>' +
        '<p class="cart-note">Shipping &amp; taxes calculated at checkout</p>' +
        '<a href="/checkout" class="checkout-btn">Proceed to Checkout</a>' +
        '<button class="cont-shop" id="contShop">Continue Shopping</button>';
      drawer.appendChild(footer);
      footer.querySelector('#contShop')?.addEventListener('click', closeCart);
    } else {
      footer.style.display = '';
      const sub = footer.querySelector('.sub-price');
      if (sub) sub.textContent = formatMoney(cart.total_price);
    }

    bindQtyButtons();
  }

  async function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    const orig = btn ? btn.textContent : '';
    // Use data attributes if present (set by Liquid), otherwise fall back to English
    const addingText = btn?.dataset.adding || 'Adding…';
    const addedText  = btn?.dataset.added  || 'Added ✓';
    if (btn) { btn.textContent = addingText; btn.disabled = true; btn.style.opacity = '0.7'; }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: qty || 1 })
      });
      if (!res.ok) { const e = await res.json(); throw new Error(e.description || 'Error'); }

      if (btn) { btn.textContent = addedText; btn.style.opacity = '1'; btn.style.background = 'var(--rose)'; btn.disabled = false; }
      await refreshCartDrawer();
      openCart();
      if (btn) setTimeout(() => { btn.textContent = orig; btn.style.background = ''; }, 2000);

    } catch(err) {
      console.error('ATC error:', err);
      if (btn) {
        btn.textContent = err.message || 'Error — try again';
        btn.style.background = '#c04040';
        btn.style.opacity = '1';
        btn.disabled = false;
        setTimeout(() => { btn.textContent = orig; btn.style.background = ''; }, 2500);
      }
    }
  }

  async function updateCartLine(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await refreshCartDrawer();
    } catch(e) { console.error('Cart update:', e); }
  }

  // QTY BUTTONS (in drawer — re-bound after each rebuild)
  function bindQtyButtons() {
    document.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const key  = this.dataset.key;
        const numEl = this.parentElement.querySelector('.qty-num');
        if (!key || !numEl) return;
        let qty = parseInt(numEl.textContent);
        qty = this.dataset.a === 'plus' ? qty + 1 : Math.max(0, qty - 1);
        numEl.textContent = qty;
        updateCartLine(key, qty);
      });
    });
    // FIX 3: Bind remove (delete) buttons
    bindRemoveButtons();
  }

  // FIX 3: Remove item from cart when trash icon clicked
  function bindRemoveButtons() {
    document.querySelectorAll('.ci-remove').forEach(btn => {
      btn.addEventListener('click', function() {
        const key = this.dataset.key;
        if (!key) return;
        // Animate the item out before removing
        const item = this.closest('.cart-item');
        if (item) {
          item.style.transition = 'opacity .25s, transform .25s';
          item.style.opacity = '0';
          item.style.transform = 'translateX(20px)';
          setTimeout(() => updateCartLine(key, 0), 260);
        } else {
          updateCartLine(key, 0);
        }
      });
    });
  }
  bindQtyButtons();

  // QUICK ADD — product grid cards
  document.querySelectorAll('.atc-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = this.dataset.variantId;
      if (variantId) {
        addToCart(variantId, 1, this);
      } else {
        // Multi-variant: go to product page
        const link = this.closest('.p-card')?.querySelector('a[href]');
        if (link) window.location.href = link.href;
      }
    });
  });

  // PRODUCT PAGE FORM
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();

      // FIX 2: Check the currently selected variant option.
      // If it is disabled (sold out) do NOT add to cart.
      const select = this.querySelector('[name="id"]');
      if (!select || !select.value) return;

      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.disabled) {
        // Show sold-out feedback on the button and bail out
        const btn = this.querySelector('.product-atc');
        if (btn) {
          const orig = btn.textContent;
          btn.textContent = 'Sold Out — Select a Size';
          btn.style.background = '#9A8F86';
          setTimeout(() => {
            btn.textContent = orig;
            btn.style.background = '';
          }, 2500);
        }
        return; // ← hard stop, nothing added to cart
      }

      const variantId = select.value;
      const btn = this.querySelector('.product-atc');
      addToCart(variantId, 1, btn);
    });
  }

  // COLOR SWATCHES
  document.querySelectorAll('.p-card__colors').forEach(grp=>{
    grp.querySelectorAll('.color-dot').forEach(d=>{
      d.addEventListener('click',function(){
        this.closest('.p-card__colors').querySelectorAll('.color-dot').forEach(x=>x.classList.remove('on'));
        this.classList.add('on');
      });
    });
  });

  // PRODUCT GALLERY THUMBS
  const thumbs=document.querySelectorAll('.product-gallery__thumb');
  const mainImg=document.getElementById('mainProductImg');
  thumbs.forEach(t=>{
    t.addEventListener('click',()=>{
      thumbs.forEach(x=>x.classList.remove('active'));
      t.classList.add('active');
      const src=t.querySelector('img')?.src;
      if(mainImg&&src){mainImg.style.opacity='0';setTimeout(()=>{mainImg.src=src;mainImg.style.opacity='1';},200);mainImg.style.transition='opacity .3s';}
    });
  });

  // SIZE OPTIONS — includes FIX 2: update ATC button based on selected variant availability
  document.querySelectorAll('.size-option').forEach(opt => {
    opt.addEventListener('click', () => {
      // Only allow clicking non-sold-out options (sold-out have pointer-events:none in CSS,
      // but handle in JS too for safety)
      if (opt.classList.contains('sold-out')) return;

      opt.closest('.size-options')?.querySelectorAll('.size-option').forEach(o => o.classList.remove('active'));
      opt.classList.add('active');

      const val = opt.dataset.value;
      //console.log(val);

      // Update the hidden variant select
      const select = document.getElementById('variant-selector');
      if (select) {
        for (const option of select.options) {
          //if (option.text.includes(val)) {
            if (option.text.trim() === val) {
            select.value = option.value;
            break;
          }
        }
      }

      // Update label
      const lbl = opt.closest('[data-product-info]')?.querySelector('.variant-label span');
      if (lbl) lbl.textContent = val;

      // FIX 2: Update ATC button to reflect selected variant availability
      const atcBtn = document.getElementById('product-form')?.querySelector('.product-atc');
      if (atcBtn) {
        const selOption = select ? select.options[select.selectedIndex] : null;
        //console.log(selOption);
        if (selOption && selOption.disabled) {
          atcBtn.textContent = 'Sold Out';
          atcBtn.disabled = true;
          atcBtn.style.opacity = '0.5';
          atcBtn.style.cursor = 'not-allowed';
        } else {
          atcBtn.textContent = atcBtn.dataset.addText || 'Add to Cart';
          atcBtn.disabled = false;
          atcBtn.style.opacity = '';
          atcBtn.style.cursor = '';
        }
      }
    });
  });

  // ACCORDIONS
  document.querySelectorAll('.product-accordion').forEach(acc=>{
    acc.querySelector('.product-accordion__toggle')?.addEventListener('click',()=>{
      const was=acc.classList.contains('open');
      document.querySelectorAll('.product-accordion').forEach(a=>a.classList.remove('open'));
      if(!was)acc.classList.add('open');
    });
  });

  // FILTER TABS
  document.querySelectorAll('.filter-tab').forEach(tab=>{
    tab.addEventListener('click',()=>{
      document.querySelectorAll('.filter-tab').forEach(t=>t.classList.remove('active'));
      tab.classList.add('active');
    });
  });

  // NEWSLETTER
  document.querySelector('.nl-form')?.addEventListener('submit',e=>{
    e.preventDefault();
    const btn=document.getElementById('nlBtn');
    const input=e.target.querySelector('input');
    if(btn){btn.textContent='Subscribed ✓';btn.style.background='#2E2017';}
    if(input)input.value='';
    setTimeout(()=>{if(btn){btn.textContent='Subscribe';btn.style.background='';}},3000);
  });

  // LANGUAGE SWITCHER
  document.querySelectorAll('.lang-switcher').forEach(switcher=>{
    const btn=switcher.querySelector('.lang-btn');
    const dropdown=switcher.querySelector('.lang-dropdown');
    if(!btn||!dropdown)return;
    btn.addEventListener('click',e=>{
      e.stopPropagation();
      const isOpen=dropdown.classList.contains('is-open');
      // close all others
      document.querySelectorAll('.lang-dropdown').forEach(d=>d.classList.remove('is-open'));
      document.querySelectorAll('.lang-btn').forEach(b=>b.setAttribute('aria-expanded','false'));
      if(!isOpen){
        dropdown.classList.add('is-open');
        btn.setAttribute('aria-expanded','true');
      }
    });
  });
  document.addEventListener('click',()=>{
    document.querySelectorAll('.lang-dropdown').forEach(d=>d.classList.remove('is-open'));
    document.querySelectorAll('.lang-btn').forEach(b=>b.setAttribute('aria-expanded','false'));
  });
setTimeout(function() {
    document.body.classList.add("globo-loaded");
  }, 300); // small delay for Globo init
});
